import React, { Fragment, useState } from "react";
import { FaUserGear } from "react-icons/fa6";

import { useNavigate } from "react-router";
import Cookies from "js-cookie";

const { forwardRef, useRef, useImperativeHandle } = React;

const LogOutModal = forwardRef(({}, ref) => {

    const [visible, setVisible] = useState(false)

    useImperativeHandle(ref, () => ({
        showModal() {
            setVisible(!visible);
        }
    }));
    const navigation = useNavigate()

    const logOut = () => {
        Cookies.remove("liResponse");
        navigation('/login')
    }

    return (
        <Fragment>
            <div className={`fixed top-0 right-[50%] w-[300px] mr-[-150px] md:w-[700px] md:mr-[-350px] mt-[5%] overflow-hidden transition-all z-[1023] rounded-3xl bg-gray-100 dark:bg-gray-800 mx-auto opacity-0 invisible ${visible && 'mt-[10%] !visible opacity-100'}`} >
                <div className="w-full h-14 flex justify-between items-center px-4">
                    <p className="flex items-center gap-x-2 text-lg text-gray-800 dark:text-white">
                        <FaUserGear size={24} />
                        کاربر گرامی
                    </p>
                </div>
                <div className="border-b-2 w-11/12 mx-auto"></div>
                <div className="w-full flex justify-center items-center px-6 py-6 text-gray-800 dark:text-white">
                    توکن شما منقضی شده است، لطفا دوباره وارد شوید.
                </div>

                <div className="flex gap-x-2 items-center justify-end w-full p-3">
                    <button
                        onClick={logOut}
                        type="button"
                        className="inline-block transition-all rounded-3xl bg-blue-600  hover:bg-blue-700 px-14 pb-2 pt-2 text-md font-medium uppercase leading-normal text-white shadow-danger-3 transition duration-150 ease-in-out hover:bg-danger-accent-300 hover:shadow-danger-2 focus:bg-danger-accent-300 focus:shadow-danger-2 focus:outline-none focus:ring-0 active:bg-danger-600 active:shadow-danger-2 motion-reduce:transition-none dark:shadow-black/30 dark:hover:shadow-dark-strong dark:focus:shadow-dark-strong dark:active:shadow-dark-strong">
                        ورود
                    </button>
                </div>

            </div>
            <div className={`fixed top-0 right-0 w-full h-full bg-black/70 z-[1022] invisible opacity-0 ${visible && '!visible opacity-100'}`}></div>
        </Fragment>
    )
}
)

export default LogOutModal